module.exports = __webpack_public_path__ + "img/div6-2.e0c0e1c4.jpg";